export const languages = [
  { name: "Español", key: "es" },
  //{ name: "Ingles", key: "en" },
  { name: "Portugues", key: "pt" },
]
